import React, { useState, useRef } from 'react';
import Picker from 'emoji-picker-react';
import { IMessage } from 'models';
import { uploadImages } from "services/aws-upload";
import AttachmentIcon from 'assets/icons/attachment.svg';
import EmojiIcon from 'assets/icons/emoji.svg';
import SendIcon from 'assets/icons/sendIconNew.svg';

interface PrivateChatInputProps {
  onMessage: (message: string, replyTo?: IMessage | null) => void;
}

const PrivateChatInput: React.FC<PrivateChatInputProps> = ({ onMessage }) => {
  const [message, setMessage] = useState('');
  const [showEmojiModal, setShowEmojiModal] = useState(false);
  const [replyTo, setReplyTo] = useState<IMessage | null>(null);
  const imageUploader = useRef<HTMLInputElement>(null);

 return (
  <div className="w-full bg-[#1E1F24] px-4 py-4 rounded-b-lg flex items-end gap-3">
    <div className="flex-1">
      <textarea
        rows={2}
        className="w-full resize-none rounded-lg border border-[#3B4350] bg-[#24272C] px-3 py-2 text-sm text-gray-200 placeholder-[#D4D6DB] outline-none"
        placeholder="Write here..."
        value={message}
        onChange={(e) => setMessage(e.target.value)}
      />
    </div>

    <div className="flex flex-col items-center gap-3">
      <div
        className="flex items-center justify-center w-10 h-10 rounded-full border border-[#FFD369] cursor-pointer"
        onClick={() => {
          if (message.trim() !== "") {
            onMessage(message, replyTo);
            setMessage("");
          }
        }}
      >
        <img src={SendIcon} alt="send" className="w-5 h-5" />
      </div>
      <div className="flex items-center gap-3">
        <img
          src={EmojiIcon}
          alt="emoji"
          onClick={() => setShowEmojiModal(!showEmojiModal)}
          className="w-5 h-5 cursor-pointer"
        />
        <img
          src={AttachmentIcon}
          alt="attachment"
          onClick={() => imageUploader.current?.click()}
          className="w-5 h-5 cursor-pointer"
        />
        <input
          ref={imageUploader}
          className="hidden"
          type="file"
          accept="image/*"
          onChange={async (event) => {
            if (event.target.files) {
              const file = event.target.files[0];
              const messageUrl = await uploadImages(file);
              onMessage(messageUrl, replyTo);
              setReplyTo(null);
            }
          }}
        />
      </div>
    </div>
    {showEmojiModal && (
      <div className="absolute bottom-16 right-[10px] z-50">
        <div className="rounded-xl shadow-xl border border-gray-200 overflow-hidden bg-white">
          <Picker
            searchDisabled
            skinTonesDisabled
            reactionsDefaultOpen={false}
            onEmojiClick={(el) => setMessage((prev) => prev + el.emoji)}
            width={250}
            height={250}
          />
        </div>
      </div>
    )}
  </div>
);
};

export default PrivateChatInput;